import React from 'react'
import KRAKycContainer from 'containers/onboarding/KRAKycContainer'
import PanCardContainer from 'containers/KYC/PanCardContainer'
const KRAConfirmationPage = () => {
  return (
<PanCardContainer />
  )
}

export default KRAConfirmationPage